// @ts-nocheck
import React, { useState, useEffect } from 'react';
import {
  Route,
  Navigate,
  Outlet,
  useLocation,
  useNavigate,
  Link,
} from 'react-router-dom';
import { Navbar } from 'app/components/Navbar/Loadable';
import { Jelly } from '@uiball/loaders';
import { AnimatePresence } from 'framer-motion';
import { Api } from '../../store/api';
import {
  ClerkLoading,
  ClerkLoaded,
  RedirectToSignIn,
  useSession,
} from '@clerk/clerk-react';
import useUserObject from 'app/hooks/useUserObject';
import { useDispatch, useSelector } from 'react-redux';
import { useGlobalAudioSlice } from 'app/components/GlobalAudioPlayer/slice';
import { selectCurrentSong, selectIsPlaying } from 'app/components/GlobalAudioPlayer/slice/selectors';
import { usePostHog } from 'posthog-js/react';

export const AuthenticatedRoute = ({ component: C, ...props }) => {
  const { isLoaded, session, isSignedIn } = useSession();
  const [authenticating, setAuthenticating] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const { user, refetchUser } = useUserObject();
  const dispatch = useDispatch();
  const { actions: globalAudioActions } = useGlobalAudioSlice();
  const currentSong = useSelector(selectCurrentSong)
  const isPlaying = useSelector(selectIsPlaying)
  const posthog = usePostHog();

  console.log('render user: ', user);

  const { user_profile: userProfile } = user;

  // If location changes, reset audio player
  useEffect(() => { 
    if (isPlaying) {
      dispatch(globalAudioActions.setIsPlaying(false))
    }
    if (currentSong) {
      dispatch(globalAudioActions.setCurrentSong(null))
    }
  }, [location.pathname]);

  useEffect(() => {
    return () => {
      console.log('session changed: ', session, isLoaded);
      if (isLoaded && session && isSignedIn) {
        const { user } = session;
        if (user) {
          
          // Identify user in posthog
          posthog?.identify(user.id, {
            email: user.primaryEmailAddress?.emailAddress,
          })

          if (
            location.pathname === '/upgrade' ||
            location.pathname === 'upgrade'
          ) {
            if (
              userProfile.plan?.includes('creator') ||
              userProfile.plan?.includes('starter')
            ) {
              navigate('/voice-models');
            }
          }
        }
      }
    };
  }, [session]);

  return (
    <React.Fragment>
      <ClerkLoading>
        <div style={{ height: '100dvh', width: '100dvw', display: 'flex' }}>
          <div style={{ margin: 'auto' }}>
            <Jelly size={120} speed={3} color="#ff74e9" />
          </div>
        </div>
      </ClerkLoading>
      <ClerkLoaded>
        {!userProfile && !isLoaded && (
          <div style={{ height: '100dvh', width: '100dvw', display: 'flex' }}>
            <div style={{ margin: 'auto' }}>
              <Jelly size={120} speed={3} color="#ff74e9" />
            </div>
          </div>
        )}
        {/* {!userProfile && isLoaded && (
          <div style={{ height: '100vh', width: '100vw', display: 'flex' }}>
            <div style={{ margin: 'auto' }}>
              <Jelly size={120} speed={3} color="#ff74e9" />
              <p> Retrieving User Profile... </p>
              <p>
                <Link to={'/'} style={{ color: '#ff74e9' }}>
                  {' '}
                  Go To Home{' '}
                </Link>
              </p>
            </div>
          </div>
        )} */}
        <>
          {location.pathname !== '/' && <Navbar />}
          <AnimatePresence>
            <Outlet context={[userProfile, isLoaded, isSignedIn, refetchUser]} />
          </AnimatePresence>
        </>
      </ClerkLoaded>
    </React.Fragment>
  );
};
